<div class="book-list">
    @for (b of books(); track b.amazon_id) {
    <div class="book">
        <div (click)="onSelect(b)" class="my-card" id="{{b.amazon_id}}">
            <kbm-book-card [book]="b"></kbm-book-card>
        </div>
    </div>
    }
</div>